module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/6@2x_41525fda933a2fe03444c76720c20289.png";